module.exports = __webpack_public_path__ + "assets/merriweather-regular.8f84d317366794a31bc9d935e7fc2162729e5a8ea7fb7f380f62be497b8c80ea.woff";